module.exports = __webpack_public_path__ + "img/chadle_adv_05.28a84faf.png";